/**
 * Display price for unified per-video purchases (matches backend getVideoPrice).
 */
export function getVideoPriceRupees(oneTimePrices) {
  if (!oneTimePrices || typeof oneTimePrices !== "object") return 129;
  if (
    typeof oneTimePrices.videoPrice === "number" &&
    !Number.isNaN(oneTimePrices.videoPrice)
  ) {
    return oneTimePrices.videoPrice;
  }
  const legacy = Math.max(
    Number(oneTimePrices["4K"]) || 0,
    Number(oneTimePrices.HD) || 0,
    Number(oneTimePrices.MobileHD) || 0
  );
  return legacy || 129;
}
